import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';


@Component({
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrl: './home-three.component.css'
})
export class HomeThreeComponent {
  // Header state
  lastScrollTop = 0;
  isHidden = false;
  isMenuOpen = false;

  // Toggle mobile menu
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // Close mobile menu
  closeMenu() {
    this.isMenuOpen = false;
  }

  // Hide / Show header on scroll
  @HostListener('window:scroll', [])
  onScroll(): void {
    const skillsSection = document.querySelector('.skill');
    
    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
    //end skill scroll

    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    // Scroll down → hide header
    if (currentScroll > this.lastScrollTop && currentScroll > 100) {
      this.isHidden = true;
    }
    // Scroll up → show header
    else {
      this.isHidden = false;
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }
  // Header End

  //Works
  portfolioWorks =[
    {
      img:'assets/images/portfolio/gallery-11.jpg',
      title:'Digital Food',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-12.jpg',
      title:'Poster',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-13.jpg',
      title:'Blue Berry',
      category:'Branding',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-14.jpg',
      title:'Death Proof',
      category:'UI/UX Design',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-15.jpg',
      title:'Ten Branding',
      category:'Branding, UX Design',
      link: '/portfolio-detail'
    },
    {
      img:'assets/images/portfolio/gallery-16.jpg',
      title:'Old Camera',
      category:'UI/UX Design',
      link: '/portfolio-detail'
    }
  ];

  // Funfacts
  funFacts =[
    {
      number: 179,
      title: "Projects Done",
      desc: "Aenean commodo ligula eget dolor. Aenean massa.",
      displayedNumber: 0
    },
    {
      number: 27,
      title: "Employees",
      desc: "Aenean commodo ligula eget dolor. Aenean massa.",
      displayedNumber: 0
    },
    {
      number: 1000,
      title: "Happy Clients",
      desc: "Aenean commodo ligula eget dolor. Aenean massa.",
      displayedNumber: 0
    },
    {
      number: 214,
      title: "Hours of Meeting",
      desc: "Aenean commodo ligula eget dolor. Aenean massa.",
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  //Team Members
  teamMembers = [
    {
      name: 'Alexander Harvard',
      position: 'Co Founder',
      image: 'assets/images/team/team-1.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    },
    {
      name: 'Jemmy Watson',
      position: 'Designer',
      image: 'assets/images/team/team-2.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    },
    {
      name: 'Bobby Castro',
      position: 'Project Lead',
      image: 'assets/images/team/team-3.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    },
    {
      name: 'Luara Prior',
      position: 'Data Scientist',
      image: 'assets/images/team/team-4.jpg',
      socials: [
        { icon: 'bi bi-facebook', link: '#' },
        { icon: 'bi bi-twitter-x', link: '#' },
        { icon: 'bi bi-pinterest', link: '#' }
      ]
    }
  ];

  //Services
  services = [
    {
      icon: 'bi bi-transparency',
      title: 'Developing Strategy',
      description:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.'
    },
    {
      icon: 'bi bi-tools',
      title: 'Blazing Performance',
      description:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.'
    },
    {
      icon: 'bi bi-rocket-fill',
      title: 'Customer Satisfaction',
      description:
        'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.'
    }
  ];

  //Brand Logos
  brands = [
    { image: 'assets/images/brands/brand-1.png', alt: 'brand-1' },
    { image: 'assets/images/brands/brand-2.png', alt: 'brand-2' },
    { image: 'assets/images/brands/brand-3.png', alt: 'brand-3' },
    { image: 'assets/images/brands/brand-4.png', alt: 'brand-4' },
    { image: 'assets/images/brands/brand-5.png', alt: 'brand-5' },
    { image: 'assets/images/brands/brand-6.png', alt: 'brand-6' }
  ];

  brandCarouselOptions = {
    loop: true,
    margin: 50,
    autoplay: true,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 3 },
      992: { items: 5 },
      1200: { items: 5 }
    }
  };

  //Blogs 
  blogItems = [
    {
      image: 'assets/images/blogs/blog-md-1.jpg',
      alt: '01',
      category: 'Branding',
      title: "It's Like Dating Entertainment",
      date: 'Apr 29, 2025',
      link: '/blog-grid', 
    },
    {
      image: 'assets/images/blogs/blog-md-2.jpg',
      alt: '02',
      category: 'Design',
      title: 'Out of The Ruins',
      date: 'Apr 28, 2025',
      link: '/blog-grid',
    },
    {
      image: 'assets/images/blogs/blog-md-3.jpg',
      alt: '03',
      category: 'Marketing',
      title: 'Woman Lifestyle',
      date: 'Apr 27, 2025',
      link: '/blog-grid',
    },
    {
      image: 'assets/images/blogs/blog-md-4.jpg',
      alt: '04',
      category: 'Education',
      title: 'Photography Techniques',
      date: 'Apr 27, 2025',
      link: '/blog-grid',
    },
  ];

  customOptions = {
    loop: true,
    margin: 24,
    autoplay: true,
    dots: true,
    nav: false,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      768: { items: 2 },
      992: { items: 3 },
      1200: { items: 3 },
    },
  };

  // Skills
  skills = [
    { name: 'Branding', level: 94 },
    { name: 'Social Marketing', level: 89 },
    { name: 'Copy Writing', level: 90 },
    { name: 'Consulting', level: 70 }
  ];

  isScrolled = false; 

}
